import React, { Component } from 'react';
import axios from 'axios'
import { Row, Col, Card, Button, Divider } from 'antd';
import 'antd/dist/antd.css';
import '../App.css';
import userProfileImageHolder from '../user_profile.jpg';
import { Link } from 'react-router-dom';
import Image from 'react-image-resizer';
import moment from 'moment';
import NumberFormat from 'react-number-format';

const API_HOST_URL = process.env.REACT_APP_API_URL

class TripRequests extends Component {

  state = {
    bookings: [],
    trip: {}
  }

  componentDidMount() {
    this.fetchTrip()
    this.fetchBookings()
  }

  fetchBookings() {
    const tripId = this.props.match.params.tripId;
    console.log("TripId: ", tripId);
    axios.get(`${API_HOST_URL}/api/bookings/?trip=${tripId}&expand=passenger`)
      .then(res => {
        this.setState({
          bookings: res.data
        })

        console.log("bookings data: ", res.data);
      })
  }

  approveRequest = booking => {
    let bookingRecord = booking
    bookingRecord.bookingStatus = "approved";
    bookingRecord.approved = true
    bookingRecord.passenger = booking.passenger.id

    axios.patch(`${API_HOST_URL}/api/bookings/${booking.id}/`,bookingRecord)
      .then(() => {
        this.fetchBookings()
      })
  }

  rejectRequest = booking => {
    let bookingRecord = booking
    bookingRecord.bookingStatus = "rejected";
    bookingRecord.approved = false
    bookingRecord.passenger = booking.passenger.id

    axios.patch(`${API_HOST_URL}/api/bookings/${booking.id}/`,bookingRecord)
      .then(() => {
        this.fetchBookings()
      })
  }

  async fetchTrip() {
    const tripId = this.props.match.params.tripId;
    console.log("fetchTrip tripId: ", tripId);
    await axios.get(`${API_HOST_URL}/api/trips/${tripId}/?expand=user`)
      .then(res => {
        console.log("bookings data: ", res.data);
        this.setState({
          trip: res.data
        })
      })
  }

  render() {
    const { trip, bookings } = this.state
    console.log("the trip: ", trip)
    console.log("number of bookings: ", bookings)
    return (
      <div>
        <Card>
          <Row>
            <Col md={{ span: 18, offset: 3 }}>
              <h1 style={{ color: '#0099ff' }}>
                <Link to={`/trip-detail/${trip.id}`}>
                  {trip.originCity} to {trip.destinationCity}
                </Link> 
              </h1>
              <h3 style={{ fontWeight: "normal" }} className="GrayText">
                {moment(trip.departureDate).format('dddd, D MMMM YYYY')} at {moment(trip.departureTime, "hh:mm").format("hh:mm A")}
              </h3>
              {
                bookings.length > 0 &&
                <h3 style={{ fontWeight: "normal", color: "green" }} className="GrayText">
                  {trip.user && trip.user.last_name}, see who is interested in travelling with you to {trip.destinationCity} on  {moment(trip.departureDate).format('dddd, Do')}
                </h3>
              }
              
            </Col>
          </Row>


          <Row>
            <Col md={{ span: 18, offset: 3 }}>

              { bookings.length > 0 ?
                bookings.map(booking => (
                  <Col md={{ span: 12 }} sm={24} key={booking.id}>
                      <div style={{ padding: '5px' }}>
                        <Card>
                          <Row>
                            <Col md={{ span: 8 }}>
                              <div style={{ borderWidth: '0px', borderStyle: "solid", borderColor: '#4c4c4c' }}>
                                <Row>
                                  <Col md={{ span: 12 }} sm={{ span: 12 }}>
                                    <div className="image-cropper">
                                      <Image
                                        src={booking.passenger.profile.profilePhoto !== null ? booking.passenger.profile.profilePhoto : userProfileImageHolder}
                                        height={100}
                                        width={100}
                                      />
                                    </div>
                                  </Col>
                                </Row>
                              </div>
                            </Col>
                            <Col md={{ span: 16 }}>
                              <h3 style={{ color: '#0099ff' }}>
                                {booking.passenger.first_name + ' ' + booking.passenger.last_name}
                              </h3>

                              <h4 style={{ fontWeight: "normal" }} className="GrayText">{booking.passenger.profile.gender}, {booking.passenger.profile.phoneNumber}</h4>
                              <h4 style={{ fontWeight: "normal" }} className="GrayText">{booking.passengerMessage}.</h4>
                              <br />
                              <h4 style={{ color: "green" }} className="GrayText">
                                <NumberFormat value={booking.costOfSeats} displayType={'text'} thousandSeparator={true} prefix={'Ush '} style={{ color: "green", fontWeight: "bold" }} />
                              </h4>
                              <Divider />
                              {
                                booking.bookingStatus == "requested" ? 
                                <div>
                                    <Button type="primary" onClick={()=>this.approveRequest(booking)}>Accept</Button>&nbsp;
                                    <Button type="primary"  style={{backgroundColor: '#ff3d00', borderWidth: '0px'}} onClick={()=>this.rejectRequest(booking)}>Reject</Button>
                                </div>
                                :
                                <h4 style={{ color: booking.bookingStatus === "approved" ? "green" : "red", fontWeight: "bold", textTransform: "capitalize"}}>{ booking.bookingStatus }</h4>
                              }
                            </Col>
                          </Row>
                        </Card>
                      </div>
                  </Col>
                ))
                :
                <div>
                  <Divider/>
                  <h4>You don't have any requests on this trip.</h4>
                </div>
                
              }

            </Col>
          </Row>

        </Card>
      </div>
    );
  }
}

export default TripRequests;
